import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Home from './pages/Home';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [pages, setPages] = useState([Home]);

  const pagesRef = useRef(null);

  const handlePageOpen = (page) => {
      let currentPageIndex = pages.indexOf(page);

      if (currentPageIndex > -1) {
        let tempPages = pages;
        tempPages.splice(currentPageIndex, 1);
        tempPages.unshift(page);
        setPages(tempPages);
        setIsMenuOpen(false);

      }
  }


  const generatePageOpacity = (index) => {
      return 1 - (index * 0.1);
  };

  const generatePageZIndex = (index) => {
      return pages.length - index;
  };

  const generatePageTransform = (index) => {
      return (isMenuOpen) ? "translate3d(0px, 75%, "+(-200 - (50 * index))+"px)" : "translate3d(0px, 0%, 0px)";
  };


  const handleMenutoggle = () => {
    if(isMenuOpen){
       setIsMenuOpen(false);
    } else {
       setIsMenuOpen(true);
    }
  };

  return (
      <>

      <div className={isMenuOpen ? "pages-stack pages-stack--open":"pages-stack"} ref={pagesRef} >
        {pages.map((Component, index)=>
          <Component index={index}  style={{opacity: generatePageOpacity(index) ,zIndex: generatePageZIndex(index), transform: generatePageTransform(index)}} onClick={() => { if(index != 0){handlePageOpen(Component)}}} />
        )}
      </div>

      </>
  );
}

export default App;
